(() => {
  if (window.ssCartPageReady) return;
  window.ssCartPageReady = true;
  const root = window.Shopify?.routes?.root || '/';
  const page = () => document.querySelector('[data-cart-page]');
  let busy = false, queued = false;
  async function recommendations() {
    const current = page(), block = current?.querySelector('[data-cart-recommendations]');
    if (!block || block.dataset.mode !== 'related' || !block.dataset.productId || block.dataset.loaded) return;
    block.dataset.loaded = 'true';
    try {
      const url = new URL(root + 'recommendations/products', location.origin);
      url.search = new URLSearchParams({section_id: current.dataset.sectionId, product_id: block.dataset.productId, limit: 10, intent: 'related'});
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url);
      if (!response.ok) return;
      const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-cart-recommendations]');
      if (fresh && !fresh.hidden && block.isConnected) block.replaceWith(fresh);
    } catch (_) { /* The selected collection remains as a server-rendered fallback. */ }
  }
  function render(html, message, preserveDraft) {
    const old = page();
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
    if (!fresh) throw new Error('Cart updated. Please refresh this page to see the latest totals.');
    if (preserveDraft) {
      const note = old.querySelector('[name="note"]');
      if (note && fresh.querySelector('[name="note"]')) fresh.querySelector('[name="note"]').value = note.value;
      old.querySelectorAll('[data-item-key]').forEach(input => {
        if (input.value === input.defaultValue) return;
        const next = Array.from(fresh.querySelectorAll('[data-item-key]')).find(el => el.dataset.itemKey === input.dataset.itemKey);
        if (next) next.value = input.value;
      });
    }
    old.replaceWith(fresh);
    if (message) fresh.querySelector('[data-discount-status]').textContent = message;
    recommendations();
  }
  async function refresh() {
    if (!page()) return;
    if (busy) { queued = true; return; }
    busy = true;
    try {
      const url = new URL(root + 'cart', location.origin);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      url.searchParams.set('sections', page().dataset.sectionId);
      const response = await fetch(url, {cache:'no-store'});
      if (!response.ok) throw new Error('Please refresh the page to see your updated cart.');
      const sections = await response.json();
      render(sections[page().dataset.sectionId] || '', '', true);
    } catch (error) { page().querySelector('[data-cart-refresh-status]').textContent = error.message; }
    finally { busy = false; if (queued) { queued = false; refresh(); } }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-apply-discount],[data-clear-discount]');
    if (!button || !page() || busy) return;
    const form = page().querySelector('#SSCart');
    if (!form.reportValidity()) return;
    const input = form.querySelector('[data-discount-input]');
    const clear = button.hasAttribute('data-clear-discount');
    const code = clear ? '' : input.value.trim();
    const status = form.querySelector('[data-discount-status]');
    if (!clear && !code) {status.textContent = 'Enter a discount code first.';input.focus();return;}
    busy = true;
    const data = new FormData(form);
    data.set('discount', code);
    data.set('sections', page().dataset.sectionId);
    data.set('sections_url', root + 'cart');
    form.inert = true;
    status.textContent = 'Updating discounts…';
    try {
      const response = await fetch(root + 'cart/update.js', {method:'POST',body:data,headers:{Accept:'application/json'}});
      const cart = await response.json();
      if (!response.ok) throw new Error(typeof cart.description === 'string' ? cart.description : 'Unable to apply this code. Please try again.');
      const entered = code.split(',').map(value => value.trim().toLowerCase());
      const titles = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))].map(discount => discount.title?.toLowerCase());
      const valid = (cart.discount_codes || []).some(discount => discount.applicable && entered.includes(discount.code.toLowerCase())) || entered.some(value => titles.includes(value));
      const message = clear ? 'Discount codes cleared.' : valid ? 'Discount applied. Your updated savings are shown below.' : 'No item discount applied for this code. Check the code and its conditions. Shipping or customer-specific offers may require checkout.';
      render(cart.sections?.[page().dataset.sectionId] || '', message, false);
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cartRendered:true}}));
      page().querySelector('[data-discount-input]')?.focus();
    } catch (error) {status.textContent = error.message;}
    finally {form.inert = false;busy = false;if (queued) {queued=false;refresh();}}
  });
  document.addEventListener('cart:updated', event => {if (!event.detail?.cartRendered) refresh();});
  async function changeItem(input, quantity) {
    if(busy||!Number.isInteger(quantity)||quantity<0)return;
    const current=page(),note=current.querySelector('[name="note"]')?.value;
    busy=true;current.inert=true;
    try{
      const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:input.dataset.itemKey,quantity,sections:[current.dataset.sectionId],sections_url:root+'cart'})});
      const cart=await response.json();if(!response.ok)throw new Error(typeof cart.description==='string'?cart.description:'Unable to update this item. Please try again.');
      render(cart.sections?.[current.dataset.sectionId]||'','',false);
      if(note!==undefined&&page().querySelector('[name="note"]'))page().querySelector('[name="note"]').value=note;
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cartRendered:true}}));
    }catch(error){current.querySelector('[data-cart-refresh-status]').textContent=error.message;input.value=input.defaultValue;}
    finally{current.inert=false;busy=false;if(queued){queued=false;refresh();}}
  }
  document.addEventListener('click',event=>{
    const step=event.target.closest('[data-quantity-step]'),remove=event.target.closest('[data-cart-remove]');
    if(!step&&!remove)return;
    event.preventDefault();if(busy)return;
    const input=(step||remove).closest('.ss-cart-item').querySelector('[data-item-key]');
    changeItem(input,remove?0:Math.max(0,Number(input.value)+Number(step.dataset.quantityStep)));
  });
  document.addEventListener('change',event=>{if(event.target.matches('[data-cart-page] [data-item-key]')){if(event.target.reportValidity())changeItem(event.target,Number(event.target.value));}});
  document.addEventListener('ss:cart-loaded',recommendations);
  document.addEventListener('submit',async event=>{
    if(!event.target.matches('#SSCart')||event.submitter?.name==='checkout')return;
    event.preventDefault();if(busy||!event.target.reportValidity())return;
    const current=page(),form=event.target,data=new FormData(form);busy=true;current.inert=true;
    data.set('sections',current.dataset.sectionId);data.set('sections_url',root+'cart');
    try{
      const response=await fetch(root+'cart/update.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
      const cart=await response.json();if(!response.ok)throw new Error(typeof cart.description==='string'?cart.description:'Unable to update your cart.');
      render(cart.sections?.[current.dataset.sectionId]||'','',false);document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cartRendered:true}}));
    }catch(error){current.querySelector('[data-cart-refresh-status]').textContent=error.message;}
    finally{current.inert=false;busy=false;if(queued){queued=false;refresh();}}
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {
      event.preventDefault();
      event.target.closest('form').querySelector('[data-apply-discount]').click();
    }
  });
  document.addEventListener('shopify:section:load', recommendations);
  recommendations();
})();
